import { createContext } from "react";

const LoaderContext = createContext({
  isLoading: false,
});

export default LoaderContext;
